"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Money;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _Money = _interopRequireDefault(require("./Money.i18n"));

var _moneyDividedToMoney = _interopRequireDefault(require("../../../helpers/money/moneyDividedToMoney"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Money(_ref) {
  var moneyDivide = _ref.moneyDivide,
      _ref$showNullValues = _ref.showNullValues,
      showNullValues = _ref$showNullValues === void 0 ? false : _ref$showNullValues,
      _ref$showSum = _ref.showSum,
      showSum = _ref$showSum === void 0 ? false : _ref$showSum,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var pp = moneyDivide.pp,
      gp = moneyDivide.gp,
      cp = moneyDivide.cp;
  var sum = (0, _moneyDividedToMoney.default)(moneyDivide);

  var SEPARATOR = /*#__PURE__*/_react.default.createElement("span", {
    style: {
      whiteSpace: "pre"
    }
  }, "  ");

  var retArr = []; // enrich array with currency segments

  if (pp + gp + cp < 1 && !showNullValues) {
    retArr.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "0 ", formatMessage(_Money.default.cp)));
  } else {
    if (pp > 0 || showNullValues) retArr.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pp, " ", formatMessage(_Money.default.pp)));
    if (gp > 0 || showNullValues) retArr.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, gp, " ", formatMessage(_Money.default.gp)));
    if (cp > 0 || showNullValues) retArr.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cp, " ", formatMessage(_Money.default.cp)));
  } // Add summ segment if desired


  if (showSum) retArr.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "(", sum, ")")); // join array to single element with separator

  var separated = retArr.reduce(function (prev, curr, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, prev, index > 0 && SEPARATOR, curr);
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    style: style
  }, separated);
}